export const getFormattedCity = (location: string | null) => {
  if (!location) {
    return '';
  }

  return location.split(',')[0];
};
